<template>
  <div>
    <v-col style="width: 300px">
      <v-text-field
        label="Search"
        single-line
        outlined
        full-width
        prepend-inner-icon="fas fa-search"
        dense
        rounded
        @input="setModelData"
        background-color="#ffffff"
      >
      </v-text-field>
    </v-col>
  </div>
</template>
<script>
export default {
  name: "InputSearch",
  methods: {
    setModelData(val) {
      this.$emit("update", val);
    }
  }
};
</script>

<style scoped></style>
